import { Platform } from 'react-native';

/** One assistive announcement and a Tab stop on web (section summaries, list rows). */
export function focusableLabeledA11yProps(accessibilityLabel: string) {
  return {
    accessible: true as const,
    accessibilityLabel,
    ...(Platform.OS === 'web' ? { tabIndex: 0 as 0 } : {}),
  };
}
